import { Table, TableHead, TableBody, TableRow, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  ActionIconButton,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../../common/components';

const SubcontractorsDataTable = ({ data, isLoading, onEdit, onDelete, LoadingComponent }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <TableBodySkeleton variant="box" />
        ) : data && data.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
            {data.map((subcontractor, index) => (
              <Box
                key={subcontractor.uuid || index}
                sx={{
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 2,
                  p: 2,
                  backgroundColor: theme.palette.background.paper,
                }}
              >
                <Box sx={{ mb: 1 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                    {subcontractor.company}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    CUIT: {subcontractor.cuit || 'Sin CUIT'}
                  </Typography>
                </Box>

                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Razón Social
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {subcontractor.legal_business_name || 'Sin especificar'}
                  </Typography>
                </Box>

                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Dirección
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {subcontractor.address || 'Sin dirección'}
                  </Typography>
                </Box>

                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Contacto
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {subcontractor.contact_information ||
                      subcontractor.phone_number ||
                      subcontractor.email ||
                      'Sin contacto'}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(subcontractor)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(subcontractor)} />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron beneficiarios" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="subcontractors table">
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                py: { xs: 1, md: 1.5 },
              },
            }}
          >
            <HeadTableCell wmd="20%" wxs="25%">
              Nombre
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="20%">
              CUIT
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="25%">
              Razón Social
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="20%">
              Dirección
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="20%">
              Contacto
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Acciones
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((subcontractor, index) => (
              <TableRow
                key={subcontractor.uuid || index}
                sx={{
                  '& td': {
                    py: { xs: 0.75, md: 1 },
                  },
                }}
              >
                <RowTableCell fontxs="12px" fontmd="14px">
                  <Typography variant="body2" fontWeight="medium">
                    {subcontractor.company}
                  </Typography>
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {subcontractor.cuit}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {subcontractor.legal_business_name}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  <Typography variant="body2" sx={{ fontSize: { xs: '12px', md: '14px' } }}>
                    {subcontractor.address || 'Sin dirección'}
                  </Typography>
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  <Typography variant="body2" sx={{ fontSize: { xs: '12px', md: '14px' } }}>
                    {subcontractor.contact_information ||
                      subcontractor.phone_number ||
                      subcontractor.email ||
                      'Sin contacto'}
                  </Typography>
                </RowTableCell>
                <RowTableCell align="center">
                  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                    <ActionIconButton variant="edit" onClick={() => onEdit(subcontractor)} />
                    <ActionIconButton variant="delete" onClick={() => onDelete(subcontractor)} />
                  </Box>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={6} message="No se encontraron beneficiarios" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default SubcontractorsDataTable;
